<template>
  <div class="content">
    <div class="operaBtn_">
      <el-button @click="addExaminee()" plain v-if="$root.$hasbtn('添加考生')">
        <i class="iconfont icon-action-add-hover"></i>添加考生
      </el-button>
      <el-button
        @click="bulkImportBtn()"
        plain
        :class="this.multipleSelectionIds.length > 0 ? 'selectBatch' : ''"
      >
        <i class="el-icon-upload"></i>批量导入考生
      </el-button>
      <el-button id="downloadFile" @click="downloadTemplate()" plain>
        <i class="el-icon-download"></i>下载模板</el-button
      >
      <el-button @click="examRegisFlow()" plain>
        <i class="el-icon-refresh"></i>考生注册流程
      </el-button>
    </div>
    <!-- 搜索条件 -->
    <!-- <div class="flex_box"> -->
    <div class="serchTerms">
      <div class="input_box">
        <span class="labelTitle">考生姓名/账号：</span>
        <el-input
          v-model.trim="input_name"
          placeholder="请输入考生姓名"
          style="width: 200px"
        ></el-input>
      </div>
      <div class="select_box">
        <span class="labelTitle">科室：</span>
        <el-select
          v-model="departmentName"
          placeholder="全部"
          class="hosname"
          @change="handleQuery($event, 'keshi')"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in options_ks"
            :key="item.DepartmentID"
            :label="item.DepartmentName"
            :value="item.DepartmentName"
            style="width: 200px"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select_box">
        <span class="labelTitle">职称：</span>
        <el-select
          v-model="pTitle"
          placeholder="全部"
          class="hosname"
          @change="handleQuery($event, 'keshi')"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in options_zc"
            :key="item.pTitleID"
            :label="item.PTitle"
            :value="item.PTitle"
            style="width: 200px"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select_box">
        <span class="labelTitle">职位：</span>
        <el-select
          v-model="position"
          placeholder="全部"
          class="hosname"
          @change="handleQuery($event, 'keshi')"
        >
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(item, index) in position_zw"
            :key="index"
            :label="item.Position"
            :value="item.Position"
            style="width: 200px"
          >
          </el-option>
        </el-select>
      </div>
      <div class="select_box1">
        <span class="labelTitle">是否完成人脸识别审核：</span>
        <el-select
          v-model="isFaceUpload"
          @change="handleQuery($event, 'rl')"
          placeholder="请选择"
        >
          <el-option label="全部" value=""></el-option>
          <el-option label="已通过" value="1"></el-option>
          <el-option label="未通过" value="0"></el-option>
        </el-select>
      </div>
      <div class="query_btn">
        <el-button
          @click="handleQuery()"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery()"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          plain
          >重置</el-button
        >
      </div>
    </div>
    <!-- </div> -->
    <!-- 操作按钮 -->
    <div class="operaBtn">
      <!-- <el-button @click="selectAll">
        <i class="iconfont icon-shezhi"></i>全选
      </el-button> -->
      <el-button @click="listType" plain>
        <i class="iconfont icon-shezhi"></i>列表管理
      </el-button>
      <el-button
        @click="exportExams()"
        plain
        :class="this.multipleSelectionIds.length > 0 ? 'selectBatch' : ''"
      >
        <i class="iconfont icon-daochu"></i>导出考生
      </el-button>
      <!-- 11.22 还原老系统列表管理功能 -->
      <el-button @click="resetPass">
        <i class="iconfont icon-batch-shanchu"></i>批量重置密码</el-button
      >
      <el-button
        @click="deleteBatches()"
        plain
        v-if="$root.$hasbtn('批量移出医院')"
      >
        <i class="iconfont icon-batch-shanchu"></i>批量移出医院
      </el-button>
      <el-button @click="changeSubject">
        变更职称申请({{ changeTitleNum }})
      </el-button>
      <!-- <el-button @click="changes(4)"> 人脸识别照片审核</el-button> -->
      <!-- <button @click="fn">点击</button> -->
    </div>
    <!-- 表格内容 -->
    <div class="kaoshengTable">
      <el-table
        ref="table"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        @row-click="StepsListRowClick"
        @selection-change="handleSelectionChange"
        :row-key="getRowKeyOfTarget"
        v-loading="loading"
      >
        <el-table-column
          type="selection"
          width="60"
          align="center"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
          <template slot-scope="scope">
            <!-- <p v-if="index == 0">{{scope.row.UserID}}</p> -->
            <p v-if="item.value == 'kszh'">{{ scope.row.UserName }}</p>
            <p v-if="item.value == 'khxm'">{{ scope.row.RealName }}</p>
            <p v-if="item.value == 'ks'">{{ scope.row.DepartmentName }}</p>
            <p v-if="item.value == 'zc'">{{ scope.row.PTitle }}</p>
            <p v-if="item.value == 'zw'">{{ scope.row.Position }}</p>
            <p v-if="item.value == 'csny'">{{ scope.row.Birthday1 }}</p>
            <p v-if="item.value == 'gznx'">{{ scope.row.JobDate }}</p>
            <p v-if="item.value == 'tjsj'">{{ scope.row.CreateTime1 }}</p>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="scope">
            <div @click.stop="">
              <el-switch
                v-model="scope.row.IsLock"
                :inactive-value="1"
                :active-value="0"
                @change="handleStatusChange(scope.row)"
              ></el-switch>
            </div>

            <!-- {{ scope.row.IsLock }} -->
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="300">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                @click.stop="handleClick(scope.row)"
                type="text"
                size="small"
                v-if="$root.$hasbtn('编辑')"
                >编辑</el-button
              >
              <!-- <el-button type="text" size="small" @click="deriveExam(scope.row)"
                >导出</el-button
              > -->
              <el-button
                type="text"
                size="small"
                @click.stop="testDetail(scope.row)"
                v-if="$root.$hasbtn('考试详情')"
                >考试详情</el-button
              >
              <el-button
                id="resetBtn"
                type="text"
                size="small"
                v-if="$root.$hasbtn('重置密码')"
                @click.stop="resetPasswords(scope.row)"
                >重置密码</el-button
              >
              <el-button
                id="delBtn"
                type="text"
                size="small"
                v-if="$root.$hasbtn('移出医院')"
                @click.stop="acountDelete(scope.row)"
                >移出医院</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="footBox">
      <div class="footPage">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          @prev-click="handlePrevClick"
          @next-click="handleNextClick"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev,pager,next,sizes,jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 考生新增/编辑弹框 -->
    <div class="examBox">
      <el-dialog
        :title="isEdit ? '编辑考生' : '添加考生'"
        :visible.sync="dialogFormVisible"
        @closed="handleClosed"
        :close-on-click-modal="false"
        :class="isEdit === false ? 'height743' : ''"
      >
        <create-or-edit
          :is-edit="isEdit"
          :exam-id="examId"
          :faceImg="faceImg"
          :srcList="srcList"
          ref="child"
          :key="timer"
          @success="handleSuccess"
          @cancel="handleCancel"
        ></create-or-edit>
      </el-dialog>
    </div>
    <!-- 批量导入考生 -->
    <div class="bulkImportExaminee">
      <el-dialog
        title="批量导入考生"
        :visible.sync="dialogBoxVisible"
        @closed="cancelRemove"
      >
        <div class="dialogBox">
          <el-input
            v-model.trim="selectFile"
            autocomplete="off"
            readonly
          ></el-input>
          <el-button @click="selectFileData()">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传excel文件，且不超过10MB
          </div>
          <input
            type="file"
            id="files"
            ref="refFile"
            style="display: none"
            v-on:change="fileLoad"
          />
        </div>
        <div class="downloadExcel">
          <a href="kaoshengmuban.xls" target="_self" download="添加考生模板.xls"
            >下载excel模板</a
          >
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelRemove">取 消</el-button>
          <el-button type="primary" @click="uploadSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 批量删除/刪除/重置密码 弹框 -->
    <div class="deleteBatches">
      <el-dialog :title="typeTitle" :visible.sync="dialogDelVisible">
        <p>{{ content }}</p>
        <div slot="footer" class="dialog-footer">
          <el-button id="cancle" @click="dialogDelVisible = false"
            >取 消</el-button
          >
          <el-button id="success" type="primary" @click="handleSure()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 考生注册流程 -->
    <div class="examflow">
      <el-dialog title="考生注册流程" :visible.sync="dialogFlowVisible">
        <img src="" alt="" />
        <p class="code">医院归属码：{{ hosCode }}</p>
        <div class="examflowfirm">
          <div class="imgShow">
            <div class="imgTxt">
              <p v-html="'\u00a0'"></p>
              <p v-html="'\u00a0\u00a0\u00a0\u00a01.'"></p>
              <p
                v-html="
                  '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0考生前往医考拉注册'
                "
              ></p>
            </div>
            <div class="imgIcon">
              <i class="el-icon-d-arrow-right"></i>
            </div>

            <div class="imgTxt2">
              <p v-html="'\u00a0'"></p>
              <p v-html="'\u00a0\u00a0\u00a0\u00a02.'"></p>
              <p
                v-html="
                  '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0在个人中心归属处输'
                "
              ></p>
              <p
                v-html="
                  '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0入医院归属码'
                "
              ></p>
            </div>
            <div class="imgIcon">
              <i class="el-icon-d-arrow-right"></i>
            </div>

            <div class="imgTxt3">
              <p v-html="'\u00a0'"></p>
              <p v-html="'\u00a0\u00a0\u00a0\u00a03.'"></p>
              <p
                v-html="
                  '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0医院审核通过'
                "
              ></p>
            </div>
          </div>
          <div class="hint">
            <span>温馨提示</span>
            <p>
              1.为提高信息录入的准确率，请先录入医院科室信息（请前往“科室管理”）
            </p>
            <p>
              2.职称、职位、工作年限信息为考生自主录入信息，如有特殊要求，请通知本院考生按要求录入。
            </p>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFlowVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogFlowVisible = false"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 导入错误信息列表 -->
    <ImportDialog ref="importDialog" />
    <!-- 列表管理弹窗 -->
    <Popup ref="Popup" />
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import {
  examList,
  seekStudent,
  getSectionList,
  getPTitleList,
  deleteAccount,
  resetPassword,
  studentDetail,
  getHosCode,
  deleteManyStudent,
  openStudent,
  closeStudent,
  exportStudentExcel,
  importExcel,
  updateMany,
  getPositionEnum,
} from "@/services/examManager.js";
import CreateOrEdit from "./examDialog.vue";
import eventBus from "@/utils/eventBus.js";
import ImportDialog from "./ImportDialog";
import moment from "moment";
import loginvuex from "@/store/index";
import Popup from "./Popup.vue";

export default {
  components: {
    CreateOrEdit,
    ImportDialog,
    Popup,
  },
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      isLoading: false,
      loading: true,
      switch_value: true,
      // 科室
      departmentName: "",
      // 职称
      pTitle: "",
      // 职位
      position: "",
      input_name: "",
      input_account: "",
      // 科室下拉框数组
      options_ks: [],
      // 职称下拉框数组
      options_zc: [],
      // 职位下拉框数组
      position_zw: [],
      // 分页列表请求数据
      examListPara: new Object(),
      // 表格数据
      getData: [],
      currentPage: 1, //  当前页数
      pageSize: 50,
      pagesizesArr: [50, 100, 200, 300, 500],
      total: 100,
      hideValue: true,
      timer: "",
      rowdata: "", //examlist传值给detail的方法。
      multipleSelectionAll: [], // 所有选中的数据包含跨页数据
      changePageCoreRecordDataStats: true,
      idKey: "UserID",
      isFaceUpload: "", // 0是没有上传人脸信息，1是已上传
      formColumns: [
        {
          prop: "UserName",
          label: "考生账号",
          value: "kszh",
          index: 0,
        },
        {
          prop: "RealName",
          label: "考生姓名",
          value: "khxm",
          index: 1,
        },
        {
          prop: "DepartmentName",
          label: "科室",
          value: "ks",
          index: 2,
        },
        {
          prop: "PTitle",
          label: "职称",
          value: "zc",
          index: 3,
        },
        {
          prop: "Position",
          label: "职位",
          value: "zw",
          index: 4,
        },
        {
          prop: "Birthday1",
          label: "出生年月",
          value: "csny",
          index: 5,
        },
        {
          prop: "JobDate",
          label: "工作年限",
          value: "gznx",
          index: 6,
        },
        {
          prop: "CreateTime1",
          label: "提交时间",
          value: "tjsj",
          index: 7,
        },
      ],
      newform: [], // 深拷贝一份表头，此表头是动态的
      // 状态是新增还是编辑
      isEdit: false,
      // 考生id
      examId: Number,
      // 新增弹框是否显示
      dialogFormVisible: false,
      // 批量导入弹框
      dialogBoxVisible: false,
      // 批量删除显示
      dialogDelVisible: false,
      // 考生注册流程弹框
      dialogFlowVisible: false,
      // 选择文件
      selectFile: "",
      // 弹框标题
      typeTitle: "",
      // 弹框内容
      content: "",
      // 考试详情列表数组
      examDetailListArr: [],
      hosCode: "",
      // 编辑表单数据
      editData: [],
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 考生信息
      examInfoObj: {
        RealName: "",
        UserName: "",
        UserID: "",
      },
      examData: [],
      //当前选中行的信息
      stateDelInfo: "",
      stateResetInfo: "",
      status: "",
      allDatalist: [], // 全选
      allType: false, // 是否全选状态
      multipleSelection: [], // 表单选中
      multipleSelectionIds: [],
      multipleSelectionCount: 0,
      changeTitleNum: 0, // 变更人数
      faceImg: "",
      srcList: [],
    };
  },
  props: ["changes"],
  methods: {
    // 获取变更科室的人数
    async getPTitleWaitList() {
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        pageIndex: 10,
        eachPageNum: 100,
      };
      const { data } = await systemclass.PTitleWaitList(obj);
      if (data.Status == 200) {
        this.changeTitleNum = data.Data.count;
      } else {
        this.$message.error(data.Msg);
      }
    },
    changeSubject() {
      this.changes(3);
      return;
      if (this.changeTitleNum <= 0) {
        this.$message({
          message: "警告，当前没有变更职称申请",
          type: "warning",
        });
      } else {
        this.changes(3);
      }
    },
    // 开关按钮切换
    change() {
      this.switch_value = false;
      console.log(this.switch_value);
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 显示条数
    handleSizeChange(val) {
      // 改变每页显示条数的时候调用一次
      this.pageSize = val;
      this.loading = true;
      this.examListData();
      console.log(`每页 ${val} 条`);
    },
    // 分页切换
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loading = true;
      this.changePageCoreRecordDataStats = false;
      this.examListData();
    },
    handlePageData() {
      this.getData = this.getData.map((item) => {
        if (item.IsLock == null) {
          item.IsLock = 0;
        }
        if (item.Birthday != null && item.Birthday != "0000-00-00 00:00:00") {
          item.Birthday1 = moment(item.Birthday).format("YYYY-MM-DD");
        } else {
          item.Birthday1 = null;
        }
        if (item.CreateTime != null && item.Birthday != "0000-00-00 00:00:00") {
          item.CreateTime1 = moment(item.CreateTime).format("YYYY-MM-DD HH:mm");
        } else {
          item.CreateTime1 = null;
        }
        return item;
      });
      //console.log('getData ====>> ',JSON.stringify(this.getData));
    },
    // 上一页
    handlePrevClick() {
      this.examListData();
    },
    // 下一页
    handleNextClick() {
      this.examListData();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },

    // 确定
    handleSure() {
      switch (this.status) {
        case 0:
          this.handleAccountDel(this.stateDelInfo);
          this.dialogDelVisible = false;
          break;
        case 1:
          this.resetPwd(this.stateResetInfo);
          this.dialogDelVisible = false;
          break;
        case 2:
          this.handleBatchData();
          this.dialogDelVisible = false;
          break;
      }
    },

    // 多选框选中数据
    handleSelectionChange(val) {
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      this.multipleSelection = val; // 批量删除多选状态
      val.forEach((v) => {
        this.multipleSelectionIds.push(v.UserID);
      });
      this.multipleSelectionCount = this.multipleSelection.length;
      console.log(this.multipleSelectionIds, "<<=====multipleSelectionIds");
    },
    // 新增考生
    addExaminee() {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:add",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      this.isEdit = false;
      this.dialogFormVisible = true;
    },
    // 下载模板
    downloadTemplate() {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:downloadTemplate",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      const link = document.createElement("a");
      link.setAttribute("download", "添加考生模板.xls");
      link.href = "kaoshengmuban.xls";
      link.click();
    },
    // 用户状态修改
    handleStatusChange(row) {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:status",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      let text = row.IsLock === 0 ? "启用" : "禁用";
      this.$confirm("确认要" + text + row.RealName + "用户吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.changeUserStatus(row.UserID, row.IsLock);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: text + "成功",
          });
        })
        .catch(() => {
          row.IsLock = row.IsLock === 0 ? 1 : 0;
          this.$message({
            type: "info",
            message: "已取消" + text,
          });
        });
    },
    //修改用户状态
    async changeUserStatus(userId, status) {
      const reqParam = new Object();
      this.UtilFun(reqParam);
      let jsonData = {};
      switch (status) {
        case 0:
          reqParam.openID = userId;
          ({ data: jsonData } = await openStudent(reqParam));
          break;
        case 1:
          reqParam.closeID = userId;
          ({ data: jsonData } = await closeStudent(reqParam));
          break;
        default:
          break;
      }
      console.log(
        "changeUserStatusParam ==========>> ",
        JSON.stringify(reqParam)
      );
      console.log("jsonData ==========>> ", JSON.stringify(jsonData));
    },
    getRowKeyOfTarget(row) {
      return row.UserID;
    },
    // 编辑
    async handleClick(row) {
      // 获取考生人脸识别图片
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:edit",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      const obj = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
        studentID: row.UserID,
        isPassList: 1, // 来源0审核列表 1考生编辑列表
      };
      const { data } = await systemclass.getFaceImg(obj);
      this.faceImg = data.Data.faceImg;
      this.srcList = [];
      this.srcList.push(data.Data.faceImg);
      this.dialogFormVisible = true;
      this.isEdit = true;
      this.editData = [];
      this.editData.push(
        row.UserName,
        row.RealName,
        row.DepartmentName,
        row.PTitle,
        row.Position,
        row.Birthday == "0000-00-00 00:00:00" ? null : row.Birthday,
        row.UserID,
        row.JoinDate == "0000-00-00 00:00:00" ? null : row.JoinDate
      );
      this.timer = new Date().getTime();
    },
    //编辑和新增关闭对话框时触发
    handleClosed() {
      this.$refs.child.ExamForm = {};
      this.$refs.child.$refs.ExamForm.resetFields();
    },
    // 批量导入
    bulkImportBtn() {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:batchImport",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      this.dialogBoxVisible = true;
    },
    // 移出医院
    acountDelete(row) {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:movedOutHospital",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      this.status = 0;
      this.stateDelInfo = row;
      this.dialogDelVisible = true;
      this.typeTitle = "移出医院";
      this.content = `确定将姓名为${row.RealName}账号为${row.UserName}考生移出医院吗？移出后，考生将不再归属医院名下`;
    },

    // 批量移出
    deleteBatches() {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:batchMovedOutHospital",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      if (this.multipleSelectionIds.length < 1) {
        this.$message.warning("请选择要导出的考生");
        return;
      }
      this.status = 2;
      this.dialogDelVisible = true;
      this.typeTitle = "批量移出医院";
      this.content =
        "确定将选定考生移出医院吗？ 移出后，考生将不再归属医院名下";
    },
    // 重置密码
    resetPasswords(row) {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:restPassword",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      this.status = 1;
      this.stateResetInfo = row;
      this.dialogDelVisible = true;
      this.typeTitle = "重置密码";
      this.content = `确定重置姓名为 ${row.RealName} 账号为 ${row.UserName} 考生的密码？ 删除后，重置后密码为'Wjy123456'`;
      //this.statusSwitch(1);
    },
    // 导出考生
    exportExams() {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:export",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      if (this.multipleSelectionIds.length < 1) {
        this.$message.warning("请选择要导出的考生");
        return;
      }
      // let userIds = this.getAllSelectionUserID();
      let userIds = this.multipleSelectionIds;
      if (userIds.length <= 0) {
        return;
      }
      // 请求参数
      const exportExamParam = new Object();
      this.UtilFun(exportExamParam);
      if (userIds.length > 0) {
        exportExamParam.studentIDArr = `[${userIds}]`;
      }
      console.log(exportExamParam, " <<============ exportExamParam");
      // 请求接口
      exportStudentExcel(exportExamParam)
        .then((res) => {
          if (res.data.type === "application/vnd.openxmlformats") {
            // 文件下载
            const blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            });
            let link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "考生列表.xlsx");
            link.click();
            link = null;
            //this.$message.success("导出考生成功");
          } else {
            // 返回json
            this.$message.warning("导出文件类型错误或没有数据");
          }
        })
        .catch((err) => {
          this.$message.error("导出考生失败");
        });
    },

    // 考试详情
    async testDetail(row) {
      this.rowdata = row;
      const userID = row.UserID;
      //this.currentPage = 1;
      const testDetailListPar = new Object();
      this.UtilFun(testDetailListPar);
      //testDetailListPar.eachPageNum = this.pageSize;
      //testDetailListPar.pageIndex = this.currentPage - 1;
      testDetailListPar.eachPageNum = 10;
      testDetailListPar.pageIndex = 0;
      testDetailListPar.ksID = userID;
      console.log(testDetailListPar);
      const { data } = await studentDetail(testDetailListPar);
      console.log(data, "考试详情列表数据");
      if (data.Status === 200) {
        if (data.Data.count == 0) {
          this.$alert(
            row.RealName + " 考生尚未参加考试，无法查看考试详情",
            "温馨提示",
            {
              confirmButtonText: "确定",
            }
          );
          return;
        }
        localStorage.setItem("isreload", true);
        this.Buriedpoint({
          code: "Examinee:candidateList:testDetail",
          parent_code: "Examinee:candidateList",
        });
        // 切换到考试详情页面
        this.changes(1);
        // 给bus触发自定义事件，传递数据
        this.examDetailListArr = data.Data.data;
      } else {
        this.$message.error(data.Data);
      }
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 考生注册流程
    examRegisFlow() {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:registFlows",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      this.dialogFlowVisible = true;
      this.examRegiser();
    },
    // 导出
    deriveExam(row) {
      const link = document.createElement("a");
      link.setAttribute("download", "考生信息.xls");
      link.href = "kaoshengmuban.xls";
      link.click();
    },

    // 选择文件
    selectFileData() {
      this.$refs.refFile.dispatchEvent(new MouseEvent("click"));
    },
    // 选择本地文件
    fileLoad() {
      const selectedFile = this.$refs.refFile.files[0];
      if (!selectedFile) {
        this.selectFile = "";
        return;
      }
      let excelType = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (excelType.indexOf(selectedFile.type) == -1) {
        this.selectFile = "";
        this.$message.warning("请上传excel文件");
        return;
      }
      //选中文件的文件名
      var name = selectedFile.name;
      //选中文件的大小
      var size = (selectedFile.size / (1024 * 1024)).toFixed(2);
      console.log("文件名:" + name + " 大小:" + size + "MB ");
      if (size > 10) {
        this.$message.warning("文件的大小不能大于10M");
        return;
      }
      this.selectFile = name;
      return true;
    },
    // 取消清除
    cancelRemove() {
      this.dialogBoxVisible = false;
      this.$refs.refFile.value = "";
      this.selectFile = "";
    },
    //上传提交
    async uploadSubmit() {
      // 校验上传的文件
      const selectedFile = this.$refs.refFile.files[0];
      if (!selectedFile) {
        this.$message.error("文件不存在");
        return;
      }
      if (!this.fileLoad()) {
        return;
      }
      // 构建表单参数
      const uploadParam = new FormData();
      uploadParam.append("UserID", parseInt(this.$store.state.userID));
      uploadParam.append("id", "WU_FILE_0");
      uploadParam.append("name", selectedFile.name);
      uploadParam.append("type", selectedFile.type);
      uploadParam.append("lastModifiedDate", selectedFile.lastModifiedDate);
      uploadParam.append("size", selectedFile.size);
      uploadParam.append("file", selectedFile);
      console.log(
        "uploadParam{UserID=" +
          uploadParam.get("UserID") +
          ",id=" +
          uploadParam.get("id") +
          ",name=" +
          uploadParam.get("name") +
          ",type=" +
          uploadParam.get("type") +
          ",lastModifiedDate=" +
          uploadParam.get("lastModifiedDate") +
          ",size=" +
          uploadParam.get("size") +
          ",file=" +
          uploadParam.get("file") +
          "}"
      );
      // 请求接口进行上传
      importExcel(uploadParam)
        .then((res) => {
          if (res.data.Status == 200) {
            if (res.data.Data.failed_count == 0) {
              this.$message.success("导入考生excel成功");
              this.examListData();
              this.dialogBoxVisible = false;
              return;
            }
            if (res.data.Data.success_count > 0) {
              this.examListData();
            }
            let failObjArr = res.data.Data.failed_data;
            if (failObjArr.length > 0) {
              this.$refs.importDialog.errorMessageVisible = true;
              this.$refs.importDialog.allData = res.data.Data.failed_data;
              this.$refs.importDialog.total = res.data.Data.failed_data.length;
              this.$refs.importDialog.successCount =
                res.data.Data.success_count;
              this.$refs.importDialog.failCount = res.data.Data.failed_count;
              this.$refs.importDialog.getDataList();
            }
          } else {
            this.$message.error(res.data.Msg);
            return;
          }
        })
        .catch(() => {
          this.cancelRemove(); // 清除file
          this.$message.error("文件读取异常，请检查文件是否被占用");
        });
      return;
      // 请求接口进行上传
      const { data } = await importExcel(uploadParam);
      console.log(data);
      if (data.Status == 200) {
        if (data.Data.failed_count == 0) {
          this.$message.success("导入考生excel成功");
          this.examListData();
          this.dialogBoxVisible = false;
          return;
        }
        if (data.Data.success_count > 0) {
          this.examListData();
        }
        let failObjArr = data.Data.failed_data;
        if (failObjArr.length > 0) {
          // let errorMsg =
          //   "<strong><span>导入成功" +
          //   data.Data.success_count +
          //   "条,导入失败" +
          //   data.Data.failed_count +
          //   "条</span></strong>";
          // errorMsg += "<dl>";
          // for (let index = 0; index < failObjArr.length; index++) {
          //   const element = failObjArr[index];
          //   errorMsg += "<strong><dt>" + element.Reason + "</dt></strong>";
          //   if (index == 4) {
          //     errorMsg += "<strong><dt>...</dt></strong>";
          //     errorMsg += "</dl>";
          //     break;
          //   }
          //   if (index == failObjArr.length - 1) {
          //     errorMsg += "</dl>";
          //   }
          // }
          // this.$message({
          //   type: "error",
          //   dangerouslyUseHTMLString: true,
          //   center: true,
          //   message: errorMsg,
          // });
          this.$refs.importDialog.errorMessageVisible = true;
          this.$refs.importDialog.allData = data.Data.failed_data;
          this.$refs.importDialog.total = data.Data.failed_data.length;
          this.$refs.importDialog.successCount = data.Data.success_count;
          this.$refs.importDialog.failCount = data.Data.failed_count;
          this.$refs.importDialog.getDataList();
        }
      } else {
        this.$message.error(data.Msg);
        return;
      }
    },

    // 搜索
    handleQuery(itmes, biaoshifu) {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:search",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      if (biaoshifu === "keshi") {
        this.examListPara.departmentName = "";
        this.examListPara.PTitle = "";
        this.examListPara.Position = "";
      }
      // 初始化多选框
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      this.changePageCoreRecordDataStats = true;
      // 刷新列表
      this.currentPage = 1;
      if (this.input_name) {
        // 考生账号
        this.examListPara.seekName = this.input_account || this.input_name;
      } else {
        this.examListPara.seekName = "";
      }
      if (this.departmentName) {
        // 科室
        this.examListPara.departmentName = this.departmentName;
      } else {
        this.examListPara.departmentName = "";
      }
      if (this.pTitle) {
        // 职称
        this.examListPara.PTitle = this.pTitle;
      } else {
        this.examListPara.PTitle = "";
      }
      if (this.position) {
        // 职位
        this.examListPara.Position = this.position;
      } else {
        this.examListPara.Position = "";
      }
      if (this.isFaceUpload) {
        this.examListPara.isFaceUpload = this.isFaceUpload;
      } else {
        this.examListPara.isFaceUpload = "";
      }
      this.examListData();
      // this.examListOfCondition();
    },
    // 输入框重置
    resetQuery() {
      this.Buriedpoint(
        {
          code: "Examinee:candidateList:rest",
          parent_code: "Examinee:candidateList",
        },
        "statetime"
      );
      // 初始化条件筛选框
      this.input_name = "";
      this.input_account = "";
      this.departmentName = "";
      this.pTitle = "";
      this.position = "";
      // 初始化多选框
      this.multipleSelectionAll = [];
      this.multipleSelection = [];
      this.changePageCoreRecordDataStats = true;
      // 刷新列表
      this.currentPage = 1;
      this.examListPara.seekName = "";
      this.examListPara.departmentName = "";
      this.examListPara.PTitle = "";
      this.loading = true;
      this.examListData();
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 考生注册流程数据请求
    async examRegiser() {
      const examFlowPara = {};
      this.UtilFun(examFlowPara);
      const { data } = await getHosCode(examFlowPara);
      console.log(data);
      if (data.Status === 200) {
        this.hosCode = data.Data;
      } else {
        this.$message.error(data.Data);
      }
    },

    // 批量移出医院接口
    async handleBatchData() {
      console.log("批量移出医院接口");
      let batchDelParam = new Object();
      // let userIds = this.getAllSelectionUserID();
      let userIds = this.multipleSelectionIds;
      batchDelParam.studentIDArr = `[${userIds}]`;
      this.UtilFun(batchDelParam);
      console.log(batchDelParam);
      const { data } = await deleteManyStudent(batchDelParam);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("批量移出成功");
        this.examListData();
      } else {
        this.$message.error(data.Data);
      }
    },
    // 移出医院接口请求
    async handleAccountDel(row) {
      let deleteParam = new Object();
      deleteParam.deleteID = row.UserID;
      this.UtilFun(deleteParam);
      console.log(deleteParam);
      const { data } = await deleteAccount(deleteParam);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("移出成功");
        this.examListData();
      } else {
        this.$message.error(data.Data);
      }
    },

    // 重置密码请求
    async resetPwd(row) {
      const resetPwdParam = new Object();
      resetPwdParam.studentUserID = row.UserID;
      this.UtilFun(resetPwdParam);
      console.log(resetPwdParam);
      const { data } = await resetPassword(resetPwdParam);
      console.log(data);
      if (data.Status === 200) {
        this.$message.success("重置密码成功");
      } else {
        this.$message.error(data.Data);
      }
    },

    // 考生列表数据
    async examListData() {
      this.loading = true;
      const examListPara = this.examListPara;
      examListPara.pageIndex = this.currentPage - 1;
      examListPara.eachPageNum = this.pageSize;
      examListPara.userID = parseInt(this.$store.state.userID);
      examListPara.guid = this.$store.state.user;
      examListPara.isFaceUpload = this.isFaceUpload;
      // console.log("examListParam ====>> ", JSON.stringify(examListPara));
      try {
        const { data } = await examList(examListPara);
        //console.log("examListData ====>> ", JSON.stringify(data));
        if (data.Status === 200) {
          // allDatalist
          this.getData = data.Data.data;
          // this.duibi();
          this.handlePageData();
          this.getPTitleWaitList();
          // console.log(data.Data.data, "考生列表数据");
          this.isLoading = false;
          this.total = data.Data.count;
          // console.log(
          //   this.multipleSelection.length,
          //   "----------multipleSelection"
          // );
          // console.log(
          //   this.multipleSelectionAll.length,
          //   "----------multipleSelectionAll"
          // );
          setTimeout(() => {
            this.changePageCoreRecordDataStats = true;
            this.loading = false;
            // this.setSelectRow();
            // console.log(
            //   this.multipleSelectionAll,
            //   "<<======multipleSelectionAll"
            // );
          }, 200);
        } else {
          this.$message.error("数据获取失败");
        }
      } catch (error) {
        console.log(error, "没有通过校验");
      }
    },
    // 条件查询考生列表
    // async examListOfCondition() {
    //   const examListPara1 = new Object();
    //   examListPara1.pageIndex = this.currentPage - 1;
    //   examListPara1.eachPageNum = this.pageSize;
    //   examListPara1.userID = parseInt(this.$store.state.userID);
    //   examListPara1.guid = this.$store.state.user;
    //   // 部门ID
    //   examListPara1.departmentID = "-1";
    //   // 考生账号
    //   examListPara1.seekName = this.input_account || this.input_name;
    //   // 科室
    //   examListPara1.departmentName = this.departmentName;
    //   // 职称
    //   examListPara1.PTitle = this.pTitle;
    //   // console.log(this.departmentName, this.pTitle, "1111");
    //   // console.log(examListPara1, "2222");
    //   this.isLoading = true;
    //   const { data } = await seekStudent(examListPara1);
    //   if (data.Status === 200) {
    //     // console.log(data.Data, "条件考生列表数据");
    //     this.getData = data.Data.data;
    //     this.handlePageData();
    //     this.isLoading = false;
    //     this.total = data.Data.count;
    //   } else {
    //     this.$message.error("数据获取失败");
    //   }
    // },

    handleSuccess() {
      // 隐藏对话框
      this.dialogFormVisible = false;
      // 刷新列表
      this.examListData();
    },
    handleCancel() {
      // 隐藏对话框
      this.dialogFormVisible = false;
    },

    // 科室下拉框数据
    async getSectionData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getSectionList(sectionObj);
      if (data.Status === 200) {
        // console.log(data.Data, "科室下拉列表数据");
        this.options_ks = data.Data;
      }
    },
    // 职称下拉框数据
    async getPTitleData() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getPTitleList(sectionObj);
      if (data.Status === 200) {
        this.options_zc = data.Data;
        this.options_zc = this.options_zc.forEach((element, index) => {
          element.pTitleID = index;
        });
        this.options_zc = data.Data;
      }
    },
    // 职位下拉框数据
    async getPositionEnum() {
      const sectionObj = new Object();
      this.UtilFun(sectionObj);
      const { data } = await getPositionEnum(sectionObj);
      if (data.Status === 200) {
        this.position_zw = data.Data;
      }
    },
    // 列表管理
    listType() {
      this.$refs.Popup.listlabel = this.formColumns.map((item) => {
        return item.value;
      });
      this.$refs.Popup.dialogVisibleObj.listType = true;
    },
    // 批量重置密码
    resetPass() {
      if (this.multipleSelectionIds.length < 1) {
        this.$message.warning("请选择要重置密码的考生");
        return;
      }
      this.$confirm(
        "此操作是否将当前选中考生的密码重置为“Wjy123456”, 是否继续?",
        "批量重置密码",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          // let userIds = this.getAllSelectionUserID();
          let userIds = this.multipleSelectionIds;
          let obj = {
            studentIDArr: `[${userIds}]`,
          };
          this.UtilFun(obj);
          const { data } = await updateMany(obj);
          if (data.Status == 200) {
            this.$message({
              type: "success",
              message: data.Data,
            });
          } else {
            this.$message({
              type: "success",
              message: data.Data,
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    // 全选
    async selectAll() {
      this.allType = !this.allType;
      if (this.allType == true) {
        // 全选
        this.getData.forEach((item) => {
          this.$refs.table.toggleRowSelection(item, true);
        });
        // console.log(this.allType, "全选");
      } else if (this.allType == false) {
        // 取消全选
        this.$refs.table.clearSelection();
        // console.log(this.allType, "取消全选");
      }
    },
    fn() {
      console.log(this.multipleSelectionIds);
      console.log(this.allDatalist, "??");
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.table.toggleRowSelection(row);
        });
      } else {
        this.$refs.table.clearSelection();
      }
    },
    duibi() {
      if (this.allDatalist.length > 0) {
        console.log("冲冲冲");
        this.$nextTick(() => {
          this.allDatalist.forEach((item) => {
            this.getData.forEach((zitem) => {
              if (zitem.UserID == item) {
                console.log("记录");
                this.$refs.table.toggleRowSelection(zitem, true);
              }
            });
          });
        });
      }
    },
  },
  mounted() {
    // this.handleSuccess();
    // this.handleCancel();
    this.duibi();
  },
  created() {
    this.stateArr = [];
    // 考生列表数据
    this.examListData();
    this.getSectionData();
    this.getPTitleData();
    this.getPositionEnum();
    this.newform = JSON.parse(JSON.stringify(this.formColumns));
    localStorage.removeItem("isreload");
  },
  // beforeDestroy() {
  //   eventBus.$emit("listDataChange", this.examDetailListArr, this.rowdata)
  // },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
}
.selectBatch {
  background: red;
}
.content {
  height: 100%;
  width: 100%;
  padding: 42px 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.flex_box {
  height: 160px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  // flex-wrap: wrap;
  align-items: center;
  // justify-content: space-between;
  // padding-right: 20px;
}
.select_box1 {
  margin-top: 16px;
  margin-bottom: 14px;
  margin-left: 24px;
  ::v-deep .el-input--suffix {
    width: 120px;
  }
}
.serchTerms {
  // height: 140px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  flex-wrap: wrap;
  padding-right: 20px;

  .labelTitle {
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    // margin-left: 25px;
    margin-right: 5px;
  }

  //@at-root
  .isselectico {
    color: #1890ff;
    cursor: pointer;
    // background-color: #00d254;
  }
}

.query_btn {
  margin: 0;
  display: flex;
  ::v-deep .el-button {
    width: 88px;
    height: 40px;
    margin-left: 36px;
  }
}
.select_box {
  margin-left: 36px;
  ::v-deep .el-input--suffix {
    width: 120px;
  }
}
.operaBtn {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 849px;
  height: 40px;
  opacity: 1;
  .el-button + .el-button {
    margin-left: 24px;
  }
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 114px;
  }
  .el-button:nth-child(2) {
    background: #1890ff;
    width: 114px;
  }
  .el-button:nth-child(3) {
    background: #64b5ff;
    width: 130px;
  }
  .el-button:nth-child(4) {
    // background: #64b5ff;
    background: #1890ff;
    width: 140px;
  }
  .el-button.selectBatch {
    background: #1890ff;
  }
  .el-button:nth-child(5) {
    // background: #00d254;
    background: #e54d4d;
    width: 140px;
  }
  // .el-button:nth-child(5) {
  //   background: #ffa200;
  //   width: 141px;
  // }
  .el-button:nth-child(6) {
    background: #1890ff;
    width: 160px;
  }
  // .el-button:nth-child(7) {
  //   background: #1890ff;
  //   width: 141px;
  // }
  // .el-button:nth-child(8) {
  //   background: #1890ff;
  //   width: 141px;
  // }
}
.operaBtn_ {
  display: flex;
  margin: 0px 0px 20px 0px;
  width: 849px;
  min-height: 40px;
  opacity: 1;
  padding-top: 24px;
  .el-button + .el-button {
    margin-left: 24px;
  }
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 114px;
  }
  .el-button:nth-child(2) {
    background: #64b5ff;
    width: 130px;
  }
  .el-button:nth-child(3) {
    // background: #64b5ff;
    background: #00d254;
    width: 115px;
  }
  .el-button.selectBatch {
    background: #1890ff;
  }
  .el-button:nth-child(4) {
    background: #ffa200;
    width: 140px;
  }
}
// 分页
.footBox {
  // position: relative;
  position: fixed;
  right: 0;
  bottom: 0;
  height: 110px;
  .footPage {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    background: #fff;
    padding: 10px 24px;
    border: 1px solid #f1f1f1;
    border-radius: 10px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
    // ::v-deep .el-pagination__jump {
    //   &::before {
    //     content: "10条/页";
    //     width: 82px;
    //     border: 1px solid #d9d9d9;
    //     height: 28px;
    //     border-radius: 2px;
    //     text-align: center;
    //     display: inline-block;
    //     margin-right: 8px;
    //     cursor: pointer;
    //   }
    // }
  }
}

// 表格内容
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #8fcbff;
  color: #333333;
  opacity: 1;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
}
.kaoshengTable {
  .el-button {
    font-size: 16px;
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

// 弹框头部样式
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

::v-deep .dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button:nth-child(1) {
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
  }
  .el-button:nth-child(2) {
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
    margin-left: 50px;
  }
}
::v-deep .height743 {
  .el-dialog {
    width: 537px;
    height: 720px !important;
    // border: 1px solid red;
    border-radius: 5px 5px 0px 0px;
  }
}
::v-deep .examBox .el-dialog {
  width: 577px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}

::v-deep .examBox .el-input {
  width: 380px;
}

::v-deep .examBox .el-form-item label {
  width: 100px !important;
  text-align: left;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  font-family: "Microsoft YaHei";
}

.dialogBox {
  position: relative;
  margin-left: 24px;
}

.dialogBox .el-button {
  left: 380px;
  position: absolute;
  width: 114px;
  height: 40px;
  background: #1890ff;
  opacity: 1;
  border-radius: 4px;
  color: white;
}

// 批量导入考生
.bulkImportExaminee {
  display: flex;
  align-items: center;
}
::v-deep .bulkImportExaminee .el-dialog {
  width: 600px;
  height: 289px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}
::v-deep .bulkImportExaminee .el-input__inner {
  width: 350px !important;
}
.bulkImportExaminee .downloadExcel {
  text-decoration: underline;
  width: 91px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #1890ff;
  opacity: 1;
  margin-left: 24px;
  margin-top: 25px;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .deleteBatches .el-dialog {
  width: 421px;
  // height: 211px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
  p {
    line-height: 24px;
  }
}

.el-switch__core {
  width: 50px;
  height: 24px;
  background: #1890ff;
  opacity: 1;
  border-radius: 100px;
}

// 注册流程
::v-deep .examflow .el-dialog {
  width: 856px;
  height: 475px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}

.examflow .code {
  font-family: PingFang SC;
  font-size: 21px;
  font-weight: bold;
  line-height: 21px;
  color: #333333;
  opacity: 1;
  text-align: center;
  margin-top: -32px;
}

.examflow {
  margin-top: 30px;
  .examflowfirm {
    display: flex;
    flex-direction: column;
    .imgShow {
      margin-top: 30px;
      .imgTxt {
        width: 216px;
        height: 100px;
        font-size: 18px;
        color: #ffffff;
        position: relative;
        background-image: url("../../../../assets/examFlow/flow1.png");
        background-repeat: no-repeat;
        float: left;
        background-size: cover;
      }
      .imgTxt2 {
        width: 216px;
        height: 100px;
        font-size: 18px;
        color: #ffffff;
        position: relative;
        background-image: url("../../../../assets/examFlow/flow2.png");
        background-repeat: no-repeat;
        float: left;
        background-size: cover;
      }
      .imgTxt3 {
        width: 216px;
        height: 100px;
        font-size: 18px;
        color: #ffffff;
        position: relative;
        background-image: url("../../../../assets/examFlow/flow3.png");
        background-repeat: no-repeat;
        float: left;
        background-size: cover;
      }
      .imgIcon {
        width: 84px;
        height: 100px;
        position: relative;
        float: left;
        font-size: 30px;
        color: #1890ff;
        justify-content: center;
        align-items: center;
        align-content: space-between;
        display: flex;
      }
    }
    .hint {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 26px;
      color: #333333;
      opacity: 1;
      position: relative;
      float: left;
      margin-top: 46px;
      display: flex;
      flex-direction: column;
    }
    .dialog-footer {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 26px;
      color: #333333;
      opacity: 1;
      position: relative;
      float: left;
      margin-top: 46px;
      display: flex;
      ::v-deep .el-button {
        &:nth-child(2) {
          margin-left: 30px;
        }
      }
    }
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// ::v-deep.el-checkbox{
//   display: none;
// }
// ::v-deep .el-table__header-wrapper .el-checkbox {
//   display: none;
// }
</style>
